import { Box, Typography } from '@mui/material'
import React from 'react'

 const CancelUI = () => {
   return (
       <Box
         sx={{
           border: 'solid 5px red',
           padding: '5px',
           borderRadius: '4px',
           transform: 'rotate(-30deg)',
          backgroundColor:"white",
          width:"300px"
         }}
       >
         <Typography sx={{ color: 'red', fontWeight: '900', fontSize: '30px', width: '100%',textAlign: 'center', }}>CANCELLED</Typography>
       </Box>
   );
 }


export default CancelUI